import cloneDeep from 'lodash.clonedeep';
import { select, put, PutEffect, SelectEffect } from 'redux-saga/effects';

import { SetElementsTimingsAction, updateScribe } from 'js/actionCreators/scribeActions';
import {
  EXIT_ANIMATION_DURATION_DOCUMENT_KEY,
  EMPHASIS_ANIMATION_DURATION_DOCUMENT_KEY,
  ENTRANCE_ANIMATION_DURATION_DOCUMENT_KEY
} from 'js/config/animationOptions';
import { EMPHASIS_TWEEN_DOCUMENT_KEY, CAMERA_EASING_NONE } from 'js/config/consts';
import { animationTypeHasNoDuration } from 'js/shared/helpers/animationTypeHasNoDuration';
import { ElementAnimationStageDurationKey } from 'js/types';

import { getScribeById } from '../selectors';

export function* updateElementsTimings({
  scribeId,
  elementIds,
  propertyValuePair
}: SetElementsTimingsAction): Generator<SelectEffect | PutEffect, void, ReturnType<typeof getScribeById>> {
  const scribe = yield select(state => getScribeById(state, scribeId));

  if (!scribe) return;

  const scribeClone = cloneDeep(scribe);
  for (const property in propertyValuePair) {
    let value = propertyValuePair[property as ElementAnimationStageDurationKey];
    if (property === EXIT_ANIMATION_DURATION_DOCUMENT_KEY) {
      scribeClone.elements.forEach(el => {
        if (elementIds.includes(el.id) && el.type !== 'Camera') {
          if (!animationTypeHasNoDuration(el?.exitTween?.id)) {
            el[property] = value;
          }
        }
      });
    } else if (property === EMPHASIS_ANIMATION_DURATION_DOCUMENT_KEY) {
      scribeClone.elements
        .filter(element => elementIds.includes(element.id))
        .forEach(element => {
          if (element.type === 'Camera') return;
          element[property] = value;
          if (value === 0) {
            element[EMPHASIS_TWEEN_DOCUMENT_KEY] = undefined;
          }
        });
    } else {
      scribeClone.elements.forEach(el => {
        if (elementIds.includes(el.id)) {
          el[property as 'animationTime' | 'pauseTime'] = value;
          if (el.type === 'Camera') {
            if (property === ENTRANCE_ANIMATION_DURATION_DOCUMENT_KEY) {
              if (value === 0) {
                el.easingType = CAMERA_EASING_NONE;
              }
            }
          }
        }
      });
    }
  }

  yield put(updateScribe(scribeClone));
}
